import { render, staticRenderFns } from "./NavSearchProduct.vue?vue&type=template&id=08c8108f"
import script from "./NavSearchProduct.vue?vue&type=script&lang=js"
export * from "./NavSearchProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChevronRightIcon: require('/vercel/path0/components/icons/ChevronRightIcon.vue').default})
